import API from '../api'
import convertPagableData from '../convertPagableData'
import getUrl from './paths'

export const getCranReportById = (probe42Id, cranSectionsList = []) =>
	new Promise((resolve, reject) => {
		cranSectionsList = cranSectionsList.join(',')
		API.get(getUrl.getCranReportById, { cranSectionsList, probe42Id })
			.then((response) => {
				resolve(response.data)
			})
			.catch((error) => {
				reject(error)
			})
	})

export const getInspectionReport = (inspectionReportId) =>
	new Promise((resolve, reject) => {
		API.get(getUrl.getInspectionReportById, { inspectionReportId })
			.then((response) => {
				resolve(response.data)
			})
			.catch((error) => {
				reject(error)
			})
	})

export const getInspectionReports = (organisationId, page = 0, size = 10, status) =>
	new Promise((resolve, reject) => {
		API.get(getUrl.getInspectionReports, { organisationId, page, size, status })
			.then((response) => {
				resolve(convertPagableData(response.data))
			})
			.catch((error) => {
				reject(error)
			})
	})

export const getNewInspectionReport = (organisationId, userId) =>
	new Promise((resolve, reject) => {
		API.get(getUrl.getNewInspectionReport, { organisationId, userId })
			.then((response) => {
				resolve(response.data)
			})
			.catch((error) => {
				reject(error)
			})
	})

export const generateCranReport = (organisationId, userId) =>
	new Promise((resolve, reject) => {
		API.get(getUrl.generateCranReport, { organisationId, userId })
			.then((response) => {
				resolve(response.data)
			})
			.catch((error) => {
				reject(error)
			})
	})

export const getVoterByOption = (organisationId, userId, optionId) =>
	new Promise((resolve, reject) => {
		API.get(getUrl.getRecentVotingDetails, { organisationId, userId, optionId })
			.then((response) => {
				resolve(response.data)
			})
			.catch((err) => {
				reject(err)
			})
	})

export const getCranReport = (financialsCreditRiskReportId) =>
	new Promise((resolve, reject) => {
		API.get(getUrl.getCranReport, { financialsCreditRiskReportId })
			.then((response) => {
				resolve(response.data)
			})
			.catch((err) => {
				reject(err)
			})
	})

export const checkActiveInspectionReport = (organisationId) =>
	new Promise((resolve, reject) => {
		API.get(getUrl.checkActiveInspectionReport, { organisationId })
			.then((response) => {
				resolve(response.data)
			})
			.catch((err) => {
				reject(err)
			})
	})

export const getBusinessDetails = (organisationId) =>
	new Promise((resolve, reject) => {
		API.get(getUrl.getBusinessDetails, { organisationId })
			.then((response) => {
				resolve(response.data)
			})
			.catch((err) => {
				reject(err)
			})
	})

export const getAllCranReports = (page, filters) =>
	new Promise((resolve, reject) => {
		API.get(getUrl.getAllCranReports, { page, ...filters })
			.then((response) => {
				resolve(convertPagableData(response.data))
			})
			.catch((err) => {
				reject(err)
			})
	})
